<template>
  <div id="backState" class="w-full px-4">
    <div class="max-w-lg mx-auto">
      <button class="btn" type="button" @click="$emit('goBack')">
        ← Back
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: "BackButton",
}
</script>

<style>
#backState .btn {
  background-color: transparent;
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 0;
  border: none;
  cursor: pointer;
}
#backState .btn:hover {
  color: #374151;
}
</style>
